/* Smartparts24 · Header-Anfrage-Button, Kaufbox-Vertrauen, leerer Warenkorb */
(function () {
  'use strict';
  var WA = 'https://wa.me/4921514866267?text=';
  var d = document;

  function headerCta() {
    var right = d.querySelector('.m-header__desktop .m-header__right');
    if (!right || right.querySelector('.sp24-header-cta')) return;
    var a = d.createElement('a');
    a.className = 'sp24-header-cta';
    a.href = WA + encodeURIComponent('Hallo Smartparts24, ich habe eine Anfrage.');
    a.textContent = 'Anfrage';
    a.setAttribute('rel', 'noopener');
    right.insertBefore(a, right.firstChild);
  }

  function buyTrust() {
    var form = d.querySelector('.main-product__block-buy_buttons .m-product-form--main');
    if (!form || d.querySelector('.sp24-buytrust')) return;
    var svg = function (p) { return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="' + p + '" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="miter"/></svg>'; };
    var box = d.createElement('div');
    box.className = 'sp24-buytrust';
    box.innerHTML =
      '<ul class="sp24-buytrust__list">' +
      '<li>' + svg('M3 12.5 9 18.5 21 6') + '<span><strong>30 Tage Rückgaberecht</strong><small>für Verbraucher</small></span></li>' +
      '<li>' + svg('M2 6h12v10H2zM14 9h4l3 3v4h-7zM6 19.5a1.5 1.5 0 1 0 0 .01M17 19.5a1.5 1.5 0 1 0 0 .01') + '<span><strong>Versand ab 150 € frei</strong><small><a href="/policies/shipping-policy">Versanddetails</a></small></span></li>' +
      '<li>' + svg('M5 11h14v10H5zM8 11V7a4 4 0 0 1 8 0v4') + '<span><strong>Sicher bezahlen</strong><small>verschlüsselter Checkout</small></span></li>' +
      '</ul>';
    form.insertAdjacentElement('afterend', box);
    var help = d.querySelector('.sp24-help');
    if (help) { help.classList.add('sp24-help--moved'); box.insertAdjacentElement('afterend', help); }
    d.documentElement.classList.add('sp24-has-buytrust');
  }

  /* Leerer Warenkorb: nächster Schritt statt Sackgasse */
  function emptyCart() {
    var els = d.querySelectorAll('.m-cart-drawer__empty');
    Array.prototype.forEach.call(els, function (el) {
      if (el.querySelector('.sp24-empty')) return;
      var models = [['Smart 450', 'smart-450'], ['Smart 451', 'smart-451'], ['Roadster 452', 'smart-452'], ['Smart 453', 'smart-453'], ['forfour 454', 'smart-454']];
      var chips = models.map(function (m) { return '<a href="/collections/' + m[1] + '">' + m[0] + '</a>'; }).join('');
      var box = d.createElement('div');
      box.className = 'sp24-empty';
      box.innerHTML = '<a class="m-button m-button--primary sp24-empty__cta" href="/collections/all">Ersatzteile entdecken</a>' +
        '<p class="sp24-empty__label">Oder Modell wählen</p><div class="sp24-empty__chips">' + chips + '</div>' +
        '<a class="sp24-empty__wa" rel="noopener" href="' + WA + encodeURIComponent('Hallo Smartparts24, ich suche ein Ersatzteil.\nSmart-Modell:\nGesuchtes Teil:') + '">Teil per WhatsApp anfragen</a>';
      el.appendChild(box);
    });
  }

  function init() {
    headerCta(); buyTrust(); emptyCart();
    if ('MutationObserver' in window) {
      new MutationObserver(function () { emptyCart(); }).observe(d.body, { childList: true, subtree: true });
    }
  }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
